import { observable, action, computed } from 'mobx';

export const roundToTwo = num => (+(`${Math.round(`${num}e+2`)}e-2`));

class CalculatorStore {
  numberOfConferenceRooms = observable.box(15);

  numberOfEmployees = observable.box(15);

  numberOfDesks = observable.box(15);

  numberOfParkingSpots = observable.box(15);

  monthlyM2RentPrice = observable.box(100);

  averageEmployeeSalaryPerH = observable.box(40);

  pricePerParkingSpot = observable.box(500);

  @observable averageSizeOfConferenceRoom = 0;

  @observable conferenceRoomOptimisationRate = 0;

  @observable averageWorkingHoursPerMonth = 0;

  @observable workingHoursOptimisationRate = 0;

  @observable estimatedAreaOfOneDesk = 0;

  @observable desksOptimisationRate = 0;

  @observable parkingOptimisationRate = 0;

  @observable estimatedCostOfSensorInstallationPerDesk = 0;

  @observable costOfScreenHardwarePerRoom = 0;

  @observable subscriptionFeePerEmployeeIn5Years = 0;

  @action.bound
  setCalcData(calcData) {
    this.numberOfConferenceRooms.set(calcData.numberOfConferenceRoomsDefaultValue);
    this.numberOfEmployees.set(calcData.numberOfEmployeesDefaultValue);
    this.numberOfDesks.set(calcData.numberOfDesksDefaultValue);
    this.numberOfParkingSpots.set(calcData.numberOfParkingSpotsDefaultValue);
    this.monthlyM2RentPrice.set(calcData.monthlyM2RentPriceDefaultValue);
    this.averageEmployeeSalaryPerH.set(calcData.averageEmployeeSalaryPerHourDefaultValue);
    this.pricePerParkingSpot.set(calcData.pricePerParkingSpotDefaultValue);

    this.averageSizeOfConferenceRoom = calcData.averageSizeOfConferenceRoom.value;
    this.averageWorkingHoursPerMonth = calcData.averageWorkingHoursPerMonth.value;
    this.estimatedAreaOfOneDesk = calcData.estimatedAreaOfOneDesk.value;
    this.estimatedCostOfSensorInstallationPerDesk = calcData
      .estimatedCostOfSensorInstallationPerDesk.value;
    this.costOfScreenHardwarePerRoom = calcData.costOfScreenHardwarePerRoom.value;
    this.subscriptionFeePerEmployeeIn5Years = calcData.subscriptionFeePerEmployeeIn5Years.value;

    // optimisation rates (values are percent %):
    this.conferenceRoomOptimisationRate = calcData.conferenceRoomOptimisationRate / 100;
    this.workingHoursOptimisationRate = calcData.workingHoursOptimisationRate / 100;
    this.desksOptimisationRate = calcData.desksOptimisationRate / 100;
    this.parkingOptimisationRate = calcData.parkingOptimisationRate / 100;
  }

  @computed
  get roomOptimisation() {
    return roundToTwo(this.averageSizeOfConferenceRoom * this.numberOfConferenceRooms.get()
      * this.monthlyM2RentPrice.get() * this.conferenceRoomOptimisationRate);
  }

  @computed
  get employeeOptimisation() {
    return roundToTwo(this.averageWorkingHoursPerMonth * this.numberOfEmployees.get()
      * this.averageEmployeeSalaryPerH.get() * this.workingHoursOptimisationRate);
  }

  @computed
  get desksOptimisation() {
    return roundToTwo(this.estimatedAreaOfOneDesk * this.numberOfDesks.get()
      * this.monthlyM2RentPrice.get() * this.desksOptimisationRate);
  }

  @computed
  get parkingOptimisation() {
    return roundToTwo(this.numberOfParkingSpots.get() * this.pricePerParkingSpot.get()
      * this.parkingOptimisationRate);
  }

  @computed
  get totalOptimisationPerMonth() {
    return roundToTwo(this.roomOptimisation + this.employeeOptimisation
      + this.desksOptimisation + this.parkingOptimisation);
  }

  @computed
  get hardwareImplementationCost() {
    return roundToTwo(this.estimatedCostOfSensorInstallationPerDesk * this.numberOfDesks.get()
      + this.numberOfConferenceRooms.get() * this.costOfScreenHardwarePerRoom);
  }

  @computed
  get costOfZoniferoIn5Years() {
    return roundToTwo(this.subscriptionFeePerEmployeeIn5Years * this.numberOfEmployees.get()
      + this.hardwareImplementationCost);
  }

  @computed
  get yourReturnOfInvestmentTime() {
    return Math.round(this.costOfZoniferoIn5Years / this.totalOptimisationPerMonth) || 0;
  }
}

export default CalculatorStore;



// WEBPACK FOOTER //
// ./src/stores/Calculator.store.js